export default function Actions({ items, onClearList, sortBy, setSortBy }) {
  return (
    items.length > 0 && (
      <div className="actions">
        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="input">SORT BY INPUT ORDER</option>
          <option value="description">SORT BY DESCRIPTION</option>
          <option value="packed">SORT BY PACKED STATUS</option>
        </select>
        <button onClick={onClearList}>Clear list</button>
      </div>
    )
  );
}
